import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const HERO_IMG =
  "https://images.unsplash.com/photo-1743697706311-120044ecaf22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxjYW5jdW4lMjB0cm9waWNhbCUyMGJlYWNofGVufDB8fHx8MTc4MTcyMjgxOHww&ixlib=rb-4.1.0&q=85";

const Hero = () => {
  const { t } = useLang();

  const goToBooking = () => {
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goToServices = () => {
    const el = document.getElementById("services");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Crystal clear blue water in Cancun"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-12 pb-32 sm:pb-40 pt-32">
        <div className="max-w-3xl">
          <p
            data-testid="hero-eyebrow"
            className="text-white/90 text-xs sm:text-sm uppercase tracking-[0.3em] mb-6 animate-fade-up"
          >
            {t.hero.eyebrow}
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.05] tracking-tight animate-fade-up-delay-1"
          >
            {t.hero.title}
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 text-white/85 text-lg max-w-xl leading-relaxed animate-fade-up-delay-2"
          >
            {t.hero.subtitle}
          </p>
          <div className="mt-10 flex flex-wrap gap-4 animate-fade-up-delay-3">
            <button
              data-testid="hero-cta-book"
              onClick={goToBooking}
              className="group bg-[#C6A87C] hover:bg-[#B59669] text-[#1A1F24] px-8 py-4 text-xs uppercase tracking-[0.25em] inline-flex items-center gap-3 transition-all hover:-translate-y-0.5"
            >
              {t.hero.cta}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={goToServices}
              className="border border-white/60 hover:border-white text-white px-8 py-4 text-xs uppercase tracking-[0.25em] inline-flex items-center gap-3 transition-all hover:bg-white/10"
            >
              {t.hero.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      {/* Scrolling indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-px h-12 bg-white/40 relative overflow-hidden">
          <div className="absolute top-0 w-full h-1/2 bg-white animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
